import { useCallback } from "react";
import { useUser } from "../../../../hooks/useUser";
import { useFlavorFinderContext } from "../Provider/FlavorFinderContextProvider";
export const useDataPreparation = () => {
    const { quizResult, flavorFinderData, userJourney } = useFlavorFinderContext();
    const { user } = useUser();
    const prepareSnpPayload = useCallback((formData) => {
        return {
            ...formData,
            consent_purposes: Object.keys(formData.consent_purposes).map((element) => ({
                id: element,
                accepted: formData.consent_purposes[element],
            })),
        };
    }, []);
    const prepareEmailMetadata = useCallback((formData) => {
        const result = {};
        result.header_photo = quizResult?.headerUrl || "";
        result.email = formData.email;
        result.shop_link = quizResult?.resultsLink || "";
        result.datetime = new Date().toISOString();
        quizResult?.results.forEach((item, index) => {
            const id = index + 1;
            result[`stick_${id}_photo`] = item.imageUrl;
            result[`stick_${id}_brand`] = item.brand;
            result[`stick_${id}_title`] = item.title;
            result[`stick_${id}_background_color`] = item.backgroundColor;
            result[`stick_${id}_bg_gradient_angle`] = item.bgGradientAngle;
            result[`stick_${id}_bg_gradient_color_from`] =
                item.bgGradientColorFrom;
            result[`stick_${id}_bg_gradient_color_to`] = item.bgGradientColorTo;
        });
        return result;
    }, [quizResult]);
    const prepareQuizResults = useCallback((quizData) => {
        const email = quizData.email;
        const results = quizResult?.results.map((item, index) => ({
            ranking: index + 1,
            sku: item.sku,
        })) || [];
        const consentPurposes = Object.keys(quizData.consent_purposes).map((element) => ({
            id: element,
            accepted: quizData.consent_purposes[element],
        }));
        const send_marketing_mail = consentPurposes.find((element) => element.id === flavorFinderData.consentPolicy.marketingMailConsentId)
            ?.accepted || false;
        const answers = userJourney
            .filter(({ view, answer_id }) => (view === "question" || view === "optional") && answer_id !== undefined)
            .map(({ answer_id, question, reference_name, local_translation }) => ({
            answer_id,
            question_id: question?.question?.id,
            reference_name,
            local_translation,
        }));
        return [
            {
                entity: "quiz_results_raw",
                payload: [
                    {
                        ...(user?.uuid ? { cas_id: user.uuid } : {}),
                        answers,
                        results,
                        consents: consentPurposes,
                        email,
                        type: "FLAVOR_FINDER",
                        send_marketing_mail,
                        created_at: Math.round(new Date().getTime() / 1000),
                    },
                ],
            },
        ];
    }, [quizResult?.results, userJourney, user?.uuid, flavorFinderData.consentPolicy.marketingMailConsentId]);
    const removeConsentPurposes = (formData) => {
        return Object.values(formData.consent_purposes).reduce((obj, item, index) => {
            obj[`consent_purposes.${index}`] = item ? "on" : "off";
            return obj;
        }, {});
    };
    const prepareOmpPayload = useCallback((formData, disableSendingMailResults = false) => {
        return {
            channel: "QUIZ",
            user: {
                channel: formData.email,
            },
            quiz_dimension: [flavorFinderData.questionDimensions],
            answer_dimension: [flavorFinderData.answerDimensions],
            quiz_results: prepareQuizResults(formData),
            ...(disableSendingMailResults ? {} : { results_email_metadata: prepareEmailMetadata(formData) }),
            ...removeConsentPurposes(formData),
        };
    }, [flavorFinderData.questionDimensions, flavorFinderData.answerDimensions, prepareQuizResults, prepareEmailMetadata]);
    return { prepareOmpPayload, prepareSnpPayload };
};
//# sourceMappingURL=useDataPreparation.js.map